"use strict"; // linear

function interpolate(v0, v1, percent) {
  return v0 + (v1 - v0) * percent;
} // quadratic


function interpolateSmooth(v0, v1, percent) {
  v1 = v1 - v0; // we want our argument to be end value, not delta

  var t = percent * 2;

  if (t < 1) {
    return v1 / 2 * t * t * t * t + v0;
  }

  t -= 2;
  return -v1 / 2 * (t * t * t * t - 2) + v0;
} // http://gizma.com/easing/#quart3
// t - current time step
// v0 - start value
// v1 - end value
// d - duration


function interpolateQuad(t, v0, v1, d) {
  v1 = v1 - v0; // we want our argument to be end value, not delta

  t /= d / 2;

  if (t < 1) {
    return v1 / 2 * t * t * t * t + v0;
  }

  t -= 2;
  return -v1 / 2 * (t * t * t * t - 2) + v0;
}

module.exports = {
  interpolate: interpolate,
  interpolateSmooth: interpolateSmooth,
  interpolateQuad: interpolateQuad
};